module.exports = __webpack_public_path__ + "img/editar.cfc8ed97.svg";